import { LockKeyhole, UnlockKeyhole } from "lucide-react";
import React from "react";

import { IgIconButton, IgTextField, IgTooltip } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

import { BooleanConfigInput } from "./BooleanConfigInput";
import { JsonConfigInput } from "./JsonConfigInput";
import { ListConfigInput } from "./ListConfigInput";

export const ConfigurationInput = ({
  config,
  onChange,
  onLockedChange,
  tooltipMessage,
  title,
}: ConfigurationInputProps) => {
  const renderConfigInput = () => {
    if (config.type === "Boolean") {
      return (
        <BooleanConfigInput
          onChange={onChange}
          config={config}
          tooltipMessage={tooltipMessage}
          title={title}
        />
      );
    } else if (config.type === "List") {
      return (
        <ListConfigInput
          onChange={onChange}
          config={config}
          tooltipMessage={tooltipMessage}
          title={title}
        />
      );
    } else if (config.type === "Json") {
      return (
        <JsonConfigInput
          onChange={onChange}
          config={config}
          tooltipMessage={tooltipMessage}
          title={title}
        />
      );
    } else if (
      config.type === "String" ||
      config.type === "Integer" ||
      config.type === "Float"
    ) {
      return (
        <Grid item sx={{ width: "100%" }}>
          <IgTextField
            onChange={onChange}
            value={config.value}
            orientation={"horizontal"}
            tooltipMessage={tooltipMessage}
            label={title || toProperCaseWithSpaces(config.key)}
          />
        </Grid>
      );
    }
    return null;
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      wrap="nowrap"
    >
      <Grid item>
        {onLockedChange ? (
          <IgTooltip title="Lock this permission to prevent plan changes from impacting access">
            <IgIconButton onClick={() => onLockedChange(!config.locked)}>
              {config.locked ? (
                <LockKeyhole size={16} />
              ) : (
                <UnlockKeyhole size={16} />
              )}
            </IgIconButton>
          </IgTooltip>
        ) : config.topic === "WEB_UI_SCOPE" ||
          [
            "enable_ai",
            "enable_price_csv_download",
            "should_show_profit_in_dashboard",
            "should_show_sitewide_dashboard",
            "edit_currency_filter_for_price_tests",
            "enable_schedule_tests",
            "live_chat_enabled",
            "max_enabled_offers",
            "enable_bundle_products",
            "functions_include_subscription_products",
          ].includes(config.key) ? (
          <div style={{ width: 32, height: 32 }} />
        ) : null}
      </Grid>

      <Grid item xs={12}>
        {renderConfigInput()}
      </Grid>
    </Grid>
  );
};
